import React, {Component} from 'react'
import firebase from "../../../Config/firebase";
import {
    MDBCarousel,
    MDBCarouselCaption,
    MDBCarouselInner,
    MDBCarouselItem,
    MDBView,
    MDBMask,
    MDBContainer,
    MDBRow,
    MDBCol, MDBAlert,
    MDBTabContent, MDBNav, MDBNavItem, MDBNavLink, MDBBtn, MDBBreadcrumb, MDBBreadcrumbItem, MDBCard, MDBCardBody
} from "mdbreact";
import {Link} from "react-router-dom";
import classes from './BannerManager.module.css'
import BannerItem from "./BannerItem/BannerItem";
import common from "../../../Utils/common.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";

const db = firebase.firestore()

class BannerManager extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            banner: [],
            isSaved:false,
            activeItem: 0
        }
        console.log("hi")
    }

    componentDidMount() {
        this.getBanner()

    }

    getBanner = () => {
        db.collection("Promote")
            .doc("Banner")
            .get()
            .then(doc => {
                if (doc.exists) {
                    let allBanner = []
                    if (doc.data().hasOwnProperty("homeBanner")) {
                        doc.data().homeBanner.map(e => {
                            console.log(e)
                            allBanner.push(e)
                        })
                        this.setState({
                            banner: allBanner
                        }, () => {
                            this.setState({
                                isLoaded: true
                            })
                        })
                    }
                    else{
                        this.setState({
                            banner: []
                        }, () => {
                            this.setState({
                                isLoaded: true
                            })
                        })
                    }
                } else {
                        this.setState({
                            banner: []
                        }, () => {
                            this.setState({
                                isLoaded: true
                            })
                        })
                    }
                }
            )
            .catch(err => console.log(err))
    }

    toggle = tab => e => {
        if (this.state.activeItem !== tab) {
            this.setState({
                activeItem: tab
            });
        }
    };

    onChangeItem = (index, itemName, itemValue) => {
        let newBannner = this.state.banner
        newBannner[index][itemName] = itemValue

        this.setState({
            banner: newBannner
        })

    }

    addItem = () => {
        this.setState({
            banner: this.state.banner.concat({
                createDate: new Date(),
                title: '',
                description: '',
                link: '',
                image: 'https://via.placeholder.com/1280x600'
            })
        })
    }

    removeItem = (index) => {
        let newBannner = this.state.banner
        newBannner.splice(index, 1)

        this.setState({
            banner: newBannner,
            activeItem: 1
        })
    }

    saveList = () => {

        db.collection("Promote")
            .doc("Banner")
            .update({
                homeBanner : this.state.banner
            })
            .then(res => {
                this.setState({
                    isSaved:true
                })
                setTimeout(() => {
                    this.setState({
                        isSaved: false
                    })
                }, 2000)
            })
            .catch(err => console.log(err))
    }

    render() {
        if (this.state.isLoaded) {
            return (
                <MDBContainer>
                    <MDBRow>
                        <MDBCol xl={6} lg={6} md={12} sm={12} xs={12}>
                            <h2 className={classes.SectionTitle}>橫額管理</h2>

                            <MDBCarousel
                                activeItem={1}
                                length={this.state.banner.length}
                                showControls={true}
                                showIndicators={true}
                                className="z-depth-1"
                            >
                                <MDBCarouselInner>
                                    {
                                        this.state.banner.map((e, index) => {
                                            return (
                                                <MDBCarouselItem itemId={index + 1} key={"mdbcar" + index}>
                                                    <MDBView key={"mdbView" + index}>
                                                        <img
                                                            key={"mdbimg" + index}
                                                            className="d-block w-100"
                                                            src={e.image}
                                                            alt="First slide"
                                                        />
                                                        <MDBMask key={"mdbimgmask" + index} overlay="black-light"/>
                                                    </MDBView>
                                                    <MDBCarouselCaption key={"mdbcarcat" + index}
                                                                        className={classes.CarouselCaptionContainer}>
                                                        <Link to={{pathname: e.link}}>
                                                            <h3 key={"mdbcarcath3" + index} className="h3-responsive">
                                                                {e.title}
                                                            </h3>
                                                            <p key={"mdbcarcatp1" + index}>
                                                                {e.description}
                                                            </p>
                                                        </Link>
                                                    </MDBCarouselCaption>
                                                </MDBCarouselItem>
                                            )
                                        })
                                    }

                                </MDBCarouselInner>
                            </MDBCarousel>


                        </MDBCol>
                        <MDBCol xl={6} lg={6} md={12} sm={12} xs={12}>
                            <MDBBtn color="secondary" onClick={() => this.addItem()}>
                                Add Item
                            </MDBBtn>
                            <MDBCard>
                                <MDBCardBody>
                                    {
                                        this.state.isSaved ?
                                            <MDBAlert color="success" >
                                                Saved
                                            </MDBAlert> : ''
                                    }
                                    <MDBNav className="nav-tabs mt-5">
                                        {
                                            this.state.banner.map((e, index) => {
                                                return (
                                                    <MDBNavItem key={"mdbnavitem" + index}>
                                                        <MDBNavLink link to="#" key={"mdbnavLink" + index}
                                                                    active={this.state.activeItem === index}
                                                                    onClick={this.toggle(index)} role="tab">
                                                            {index + 1}
                                                        </MDBNavLink>
                                                    </MDBNavItem>
                                                )
                                            })
                                        }


                                    </MDBNav>
                                    <MDBTabContent activeItem={this.state.activeItem} className={classes.BannerSettingContainer}>

                                        {
                                            this.state.banner.map((e, index) => {
                                                return (
                                                    <BannerItem
                                                        index={index} key={"bannerItem" + index}
                                                        data={e}
                                                        saveList={this.saveList}
                                                        removeItem={this.removeItem}
                                                        onChangeItem={this.onChangeItem}
                                                    />
                                                )
                                            })
                                        }

                                    </MDBTabContent>
                                </MDBCardBody>
                            </MDBCard>

                        </MDBCol>
                    </MDBRow>

                </MDBContainer>
            );
        } else {
            return (
                <div>
                    loading...
                </div>
            )
        }

    }

}

export default BannerManager